module.exports = __webpack_public_path__ + "static/media/commonChest__top--closed.c76dba45.png";